module.exports = __webpack_public_path__ + "media/images/badge/tifoso-e3b6501de430550878ba45cde252bca9.png";